import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessCategoryAppResource from './BusinessCategoryAppResource';
import BusinessProfileAppResource from './BusinessProfileAppResource';
import ReferralPartnerTypeAppResource from "./ReferralPartnerTypeAppResource";

export const MORTGAGE = 'mortgage';
export const HOME_INSPECTOR = 'home-inspection';
export const CREDIT_COUNSELING = 'credit-counseling';
export const LEGAL_SERVICES = 'legal-services';
export const HOME_WARRANTY = 'home-warranty';
export const HOMEOWNERS_INSURANCE = 'homeowners-insurance';
export const HOME_STAGING = 'home-staging';
export const PHOTOGRAPHY_VISUAL_TOURS = 'photography-virtual-tours';
export const TITLE_ESCROW_SERVICES = 'title-escrow-services';
export const REAL_ESTATE_BROKERAGE = 'real-estate-brokerage';

class BusinessTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Business-Type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'businesses/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'professional',
            'directoryCategory',
            'serviceProvided',
            'businessCategory',
            'businessCategoryUuid',
            'featured',
            'slug',
            'referralPartnerTypes',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            businessCategory: BusinessCategoryAppResource,
            businessProfiles: BusinessProfileAppResource,
            businessServices: BusinessProfileAppResource,
            referralPartnerTypes: ReferralPartnerTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            businessCategory: 'business_category_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            professional: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            directoryCategory: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            serviceProvided: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            businessCategoryUuid: {
                type: 'string',
                presence: true,
            },
            featured: {
                type: 'boolean',
                presence: true,
            },
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default BusinessTypeAppResource;
